import ReactDOM from 'react-dom/client';
import App from './';
import TimeAgo from 'javascript-time-ago';

import en from 'javascript-time-ago/locale/en.json';
import pt from 'javascript-time-ago/locale/pt.json';
import {initSentry} from 'shared/util/init-sentry';

TimeAgo.addDefaultLocale(pt);
TimeAgo.addLocale(en);

initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
